import { FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useUserAuthStore } from '../../store/userAuthStore'

export default function UserPinPage() {
  const navigate = useNavigate()
  const { verifyPin, logout, isAuthenticated } = useUserAuthStore()
  const [pin, setPin] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setError(null)
    setLoading(true)

    try {
      await verifyPin(pin)
      navigate('/user')
    } catch (err: any) {
      const message = err?.message || 'Invalid PIN code'
      setError(message)
      if (isAuthenticated) {
        logout()
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-semibold text-gray-900">Enter PIN</h1>
            <p className="text-sm text-gray-600 mt-2">
              For security reasons we require a 4-digit PIN before showing user data.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="pin" className="block text-sm font-medium text-gray-700 mb-1">
                Access PIN
              </label>
              <input
                id="pin"
                type="password"
                inputMode="numeric"
                pattern="\d*"
                maxLength={4}
                value={pin}
                onChange={(event) => setPin(event.target.value.replace(/\D/g, '').slice(0, 4))}
                className="input w-full text-center text-2xl tracking-[0.5em]"
                placeholder="••••"
                autoFocus
                required
              />
            </div>

            {error && (
              <div className="rounded-lg border border-red-100 bg-red-50 px-3 py-2 text-sm text-red-700 text-center">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || pin.length !== 4}
              className="btn-primary w-full flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="h-5 w-5 animate-spin" />}
              Verify PIN
            </button>
          </form>

          <p className="mt-6 text-xs text-gray-500 text-center">
            Hint: use the test PIN provided in the task description.
          </p>
        </div>
      </div>
    </div>
  )
}
